/**
 *  Copyright (c) 2026 TechDivision GmbH
 *  All rights reserved
 *
 *  This product includes proprietary software developed at TechDivision GmbH, Germany
 *  For more information see https://www.techdivision.com/
 *
 *  To obtain a valid license for using this software please contact us at
 *  license@techdivision.com
 *
 */

/* flip-cards.js
   Turns a card on tap where there is no pointer to hover with. Shared by both
   card sections: sections/location-cards.liquid and sections/flip-cards.liquid
   differ only in what their back face holds, the turn itself is one behaviour.

   Hover and keyboard focus are handled in CSS (:hover behind a hover media
   query, :focus-within for tabbing). This module covers the third case: a touch
   screen, where neither applies and the back face would otherwise be
   unreachable.

   The hover check runs per click rather than once at start-up, so a device that
   gains or loses a pointer — a tablet with a keyboard case, a convertible — is
   handled without re-initialising. On a pointer device the click does nothing,
   because a click that toggles a state hover also controls leaves the card
   stuck open once the pointer moves away.

   The card marks itself as scripted, which is what switches the stylesheet from
   the no-JS layout (both faces stacked, everything readable) to the turn.

   Keyboard access rests on the back face having something focusable on it,
   which is what :focus-within reacts to. A location card carries a route link,
   but a free-text card has no link at all unless its text happens to hold one,
   and its back would be unreachable for anyone tabbing. Such a card becomes the
   tab stop itself: :focus-within also matches the element in focus, so the
   attribute alone does it and no key handler is needed. A card that already has
   a link keeps exactly the tab order it had. */

export function initFlipCards() {
  var cards = Array.prototype.slice.call(document.querySelectorAll('[data-flip-card]'));
  if (!cards.length) return;

  cards.forEach(function (card) {
    card.setAttribute('data-flip-scripted', '');

    var back = card.querySelector('.flip-card__back');
    if (back && !back.querySelector('a[href], button, input, select, textarea, [tabindex]')) {
      card.setAttribute('tabindex', '0');
    }

    card.addEventListener('click', function (event) {
      // a tap on a link inside the card has to follow the link
      if (event.target.closest && event.target.closest('a')) return;
      if (window.matchMedia && window.matchMedia('(hover: hover)').matches) return;

      card.classList.toggle('is-flipped');
    });
  });
}

// loaded as a module script by the section that needs it (see
// snippets/module-script.liquid), so the module initialises itself. module
// scripts are deferred, which means the DOM is complete at this point
initFlipCards();
